module.exports = __webpack_public_path__ + "static/logo-12ed476baf13135d71d54647101c16c1.png";